import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import ArticleCard from "./ArticleCard";

/**
 * « À lire aussi » : 3 articles, en priorité du même thème que l'article lu,
 * complétés par les plus récents des autres thèmes. Masqué s'il n'y a rien à proposer.
 */
export default function RelatedArticles({ currentSlug, category }) {
  const { data: articles = [] } = useQuery({
    queryKey: ["articles", "all"],
    queryFn: async () => (await api.get("/articles")).data,
  });

  const others = articles.filter((a) => a.slug !== currentSlug);
  const sameTheme = others.filter((a) => a.category === category);
  const rest = others.filter((a) => a.category !== category);
  const picks = [...sameTheme, ...rest].slice(0, 3);
  if (picks.length === 0) return null;

  return (
    <section className="mx-auto max-w-7xl px-6 pt-6 pb-10 sm:pb-4" data-testid="related-articles">
      <div className="border-t border-white/5 pt-8 sm:pt-12">
        <div className="flex items-end justify-between gap-4 mb-6">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-violet-400 mb-2">À lire aussi</div>
            <h2 className="font-display font-black text-2xl sm:text-3xl">
              {sameTheme.length > 0 ? "Sur le même thème" : "Nos dernières analyses"}
            </h2>
          </div>
          <Link to="/articles" className="text-sm text-zinc-400 hover:text-emerald-400 inline-flex items-center gap-1 shrink-0">
            Toutes les analyses <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {picks.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      </div>
    </section>
  );
}
